import { render, staticRenderFns } from "./OrderMenus.vue?vue&type=template&id=74f21826"
import script from "./OrderMenus.vue?vue&type=script&lang=ts"
export * from "./OrderMenus.vue?vue&type=script&lang=ts"
import style0 from "./OrderMenus.vue?vue&type=style&index=0&id=74f21826&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports